export default {
  profile: {
    months_one: '{{count}} month', months_other: '{{count}} months',
    period: { free: 'free', trial: 'trial period', trial5: 'trial period · 5 days' },
    method: { card: 'Card · CloudPayments', crypto: 'Crypto · NOWPayments' },
    offer: { plus: 'up to 5 coins · 30 Orca AI questions · macro, calendar, forecast, Price Alerts, X Radar, YouTube', premium: 'up to 8 coins · 55 Orca AI questions · everything in Plus, OrcaWatch and Wall Street Digests' },
    err: {
      applying: 'Payment received. Your plan is being switched on — this usually takes up to a minute.', pendingReal: 'The payment provider has not confirmed the payment yet. If you have paid, check again in a couple of minutes.',
      canceled: 'Payment canceled. Nothing was charged — you can choose a plan again.', expired: 'The payment window has expired. Create a new payment.',
      trialUsed: 'The Plus trial has already been used on this account.', missing: 'Payment not found. Go back to choosing a plan.',
      pending: 'Payment not confirmed yet. Wait 5 minutes and check again.', failed: 'Payment failed. Nothing was charged — try again or choose another method.',
      coinLimit: 'The {{plan}} plan allows up to {{n}} coins.',
    },
  },
};
